import { render } from "./TipiPagamento.vue?vue&type=template&id=8086099c"
import script from "./TipiPagamento.vue?vue&type=script&lang=js"
export * from "./TipiPagamento.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__